class ExportFormatter {
  constructor(model, opts = {}) {
    if (new.target === ExportFormatter) {
      throw new TypeError('Cannot construct instances of ExportFormatter directly');
    }
    if (this.writeData === undefined) {
      throw new TypeError('Subclasses of ExportFormatter must implement `writeData`');
    }
    const {
      exportModel,
      ...rest
    } = opts;
    this.model = model;
    this.exportModel = exportModel;
    this.options = rest;
  }

  /** To be used optionally by subclasses to perform setup work each time that an export begins */
  init() {}

  /** To be used optionally by subclasses to perform cleanup work each time that an export is complete */
  end() {}
  onError() {}
}
export default ExportFormatter;